<div style="display: flex;align-items: center;gap:10px;margin-bottom: 15px;">
    <input #input class="input text-input" style="width: 75%;"
        [ngStyle]="{'color':invalid?'red':'','border':invalid?'1px solid red':'','border-radius':invalid?'6px':''}"
        [value]="address ? address : ''" [placeholder]="placeholder">
    <button class="nnb-btn-secondary nnb-btn-md" [disabled]="searching" [attr.aria-busy]="searching"
        (click)="search(input.value)">{{ searching ? '검색 중…' : '검색' }}</button>
</div>
<!-- 번지를 못 찾아 마을·구역 중심으로 접힌 좌표. 지도의 핀을 끌면 사라진다. -->
<div *ngIf="approximate" role="status"
    style="margin-bottom: 10px;padding: 8px 12px;border: 1px solid #f0c36d;border-radius: 6px;background: #fdf6e3;font-size: 0.875rem;color: #7a5c00;">
    번지까지 찾지 못해 <strong>대략적인 위치</strong>입니다.
    <ng-container *ngIf="canDragPin; else refineAddress">지도에서 핀을 끌어 정확한 위치로 옮겨주세요.</ng-container>
    <ng-template #refineAddress>주소를 더 정확히 입력한 뒤 다시 검색해주세요.</ng-template>
</div>
<!-- 국내 좌표인데 시군구를 못 채운 상태. 이대로 저장하면 지도 검색의 지역 필터에서 빠진다. -->
<div *ngIf="regionUnresolved" role="status"
    style="margin-bottom: 10px;padding: 8px 12px;border: 1px solid #f0c36d;border-radius: 6px;background: #fdf6e3;font-size: 0.875rem;color: #7a5c00;">
    <strong>지역 정보(시·군·구)를 채우지 못했습니다.</strong> 이대로 저장하면 지도 검색의 지역 필터에 노출되지 않습니다.
</div>
<!-- 구글 지도 초기화 실패. 팝업은 한 번 닫히면 사라지므로 상태를 여기 남긴다. -->
<div *ngIf="googleMapFailed" role="status"
    style="margin-bottom: 10px;padding: 8px 12px;border: 1px solid #f0a0a0;border-radius: 6px;background: #fdf0f0;font-size: 0.875rem;color: #8a2020;">
    지도를 불러오지 못했습니다. 좌표는 저장되지만 핀을 끌어 위치를 보정할 수 없습니다.
</div>
<div [id]="id" style="height:15.313rem;border: 1px solid #e2e2e2;border-radius: 4px;"></div>
